@if (!hasResult) {
  <app-advisor-errorpage></app-advisor-errorpage>
}

@if (hasResult) {
  <div>
    <div class="grid-x grid-margin-x headline-wrapper">
      <div class="cell small-12 large-12">
        <dialog-hint [showPdfAndPrintIcons]="false" textkey="moderat.verbrauchsanalyse.ergebnis.callout"  remeberCloseId="moc-result-hint" [closable]="true"></dialog-hint>
      </div>
      <div class="cell small-12 large-offset-1 large-10 text-center">
        <h1 [innerHTML]="'moderat.verbrauchsanalyse.ergebnis.headline' | translate: placeholder"></h1>
      </div>
    </div>
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 medium-10 medium-offset-1">
        <app-building-condition [textPlaceholder]="placeholder" (stageSet)="setStage($event)" textKeyPrefix="moderat.verbrauchsanalyse.ergebnis.condition" [isApartementBuilding]="false" [value]="result['evkw']" [min]="result['evkw_minimum']" [max]="result['evkw_maximum']" [avg]="result['evkw_durchschnitt']"></app-building-condition>
      </div>
    </div>
    <div class="arrow-down-wrapper">
      <h2 class="text-center" [innerHTML]="'moderat.verbrauchsanalyse.ergebnis.description' | translate: placeholder"></h2>
      <div class="grid-x grid-margin-x">
        <div class="cell small-12 large-offset-2 medium-offset-1 medium-5 large-4">
          <h3 [innerHTML]="'moderat.verbrauchsanalyse.ergebnis.energy.headline' | translate: placeholder"></h3>
          <p [innerHTML]="('moderat.verbrauchsanalyse.ergebnis.energy.text.' + stage) | translate: placeholder"></p>
        </div>
        <div class="cell small-12 medium-5 large-4 end">
          <h3 [innerHTML]="'moderat.verbrauchsanalyse.ergebnis.co2.headline' | translate: placeholder"></h3>
          <p  [innerHTML]="'moderat.verbrauchsanalyse.ergebnis.co2.text' | translate: placeholder"></p>
        </div>
      </div>
      <span class="copyright" [innerHTML]="'moderat.verbrauchsanalyse.ergebnis.copyright' | translate"></span>
    </div>
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 medium-10 medium-offset-1">
        <div class="button-wrapper background">
          <div class="grid-x grid-margin-x">
            <div class="cell small-12">
              <p [innerHTML]="('moderat.verbrauchsanalyse.ergebnis.footer.' + stage) | translate: placeholder"></p>
              <p [innerHTML]="('moderat.verbrauchsanalyse.ergebnis.footer.' + path) | translate: placeholder"></p>
            </div>
          </div>
          <app-step-buttons previousLink="../../verbrauchsanalyse/verbrauchsdaten" nextText="moderat.verbrauchsanalyse.ergebnis.submit" [nextLink]="hasResult? '../../bestandsaufnahme' : null" [nextSubmit]="false" largeOffset="0" mediumWidthRight="auto" largeWidthRight="auto"></app-step-buttons>
        </div>
      </div>
    </div>
  </div>
}
